import type { IconData } from '@stacksjs/iconify-core'

export const colorPicker: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M18.998 14.132L7.459 25.671c-1.637 1.637-2.86 3.72-2.829 6.035c.032 2.364.489 4.182.489 4.182l-2.11 5.33C2.3 43.004 4.995 45.7 6.781 44.992l5.24-2.2s1.756.44 4.088.513c2.425.075 4.628-1.174 6.344-2.89L33.86 29.008M19.5 21.63l-5.274 5.275\"/><path d=\"M41.076 6.927c-4.45-4.456-11.663-4.456-16.112 0l-1.842 1.845l-.55-.51c-1.214-1.117-2.87-1.31-4.064-.173a22 22 0 0 0-.784.785c-1.135 1.197-.943 2.855.172 4.07c1.475 1.61 4.053 4.331 8.34 8.625c4.287 4.295 7.004 6.877 8.61 8.354c1.213 1.117 2.87 1.31 4.064.173a23 23 0 0 0 .784-.785c1.135-1.197.942-2.855-.173-4.07q-.14-.155-.294-.32l1.849-1.852c4.45-4.458 4.45-11.685 0-16.142\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default colorPicker
